import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="fixed top-24 right-4 z-40">
      <button
        onClick={toggleLanguage}
        className="flex items-center space-x-2 bg-white/10 backdrop-blur-lg border border-white/20 rounded-lg px-3 py-2 text-white hover:bg-white/20 transition-all duration-300 group"
        title={i18n.language === 'fr' ? 'Switch to English' : 'Passer au Français'}
      >
        <Globe size={16} className="group-hover:animate-spin" />
        <span className="text-sm font-medium">
          {i18n.language === 'fr' ? 'EN' : 'FR'}
        </span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;